/**
 * Product images and offer details.
 *
 * HERO_IMAGE: mockup of the six volumes (2048×1360). If emptied, the hero and
 * the pricing card draw the six volumes in code instead.
 */
export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/gXtzsvx5qwrvJT1Pf17DjD/Photorealistic-product-mockup-photograph.png'

export const HERO_IMAGE_ALT =
  'The six Track Coach Ready volumes: Day One Ready, Speed Ready, Jumps Ready, Throws Ready, Distance Ready and Meet Season Ready'

/** Where the pricing-card button sends the coach. Replace with the real checkout link. */
export const CHECKOUT_URL = 'https://track-coach-ready.impultienda.ar/checkout'

/** Offer, in USD. */
export const PRICE = 27
export const TOTAL_VALUE = 97
export const PRICE_AFTER_LAUNCH = 47

/** Support inbox shown in the footer. */
export const SUPPORT_EMAIL = 'help@iclcollective.com'
